import PropTypes from 'prop-types'
import { baseSlicePropTypes } from '../slice.types'

/**
 * @typedef {Object} VendorAddress
 * @property {string} id
 * @property {string} address_line_1
 * @property {string} address_line_2
 * @property {string} city
 * @property {string} state
 * @property {string} zip
 * @property {string} country_code
 * @property {string} phone
 * @property {string} email
 * @property {string} address_residential_indicator
 * @property {Array} address_errors
 * @property {number} vendor_id
 */

/**
 * @typedef {Object} VendorAddressesSlice
 * @extends {import('../slice.types').BaseSlice}
 * @property {Object.<string, VendorAddress>} data
 */

export const VENDOR_ADDRESSES_ACTIONS = {
  SET_VENDOR_ADDRESSES: 'SET_VENDOR_ADDRESSES',
  SET_VENDOR_ADDRESS: 'SET_VENDOR_ADDRESS',
  SET_STATUS: 'SET_VENDOR_ADDRESSES_STATUS',
  SET_ERRORS: 'SET_VENDOR_ADDRESSES_ERRORS',
  CLEAR_ERRORS: 'CLEAR_VENDOR_ADDRESSES_ERRORS'
}

export const initialVendorAddressesState = {
  status: 'idle',
  errors: [],
  data: {}
}

export const vendorAddressesPropTypes = {
  ...baseSlicePropTypes,
  data: PropTypes.objectOf(
    PropTypes.shape({
      id: PropTypes.string,
      address_line_1: PropTypes.string,
      address_line_2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      country_code: PropTypes.string,
      phone: PropTypes.string,
      email: PropTypes.string,
      address_residential_indicator: PropTypes.string,
      address_errors: PropTypes.array,
      vendor_id: PropTypes.number
    })
  )
}
